import { Suspense, lazy } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './swagger.css'
import './header.css'

import LoginPage from './pages/LoginPage'
import ProtectedRoute from './components/ProtectedRoute'

const DocsPage = lazy(() => import('./pages/DocsPage'))
// Painel interno: chunk separado, quem só lê a documentação não baixa.
const AdminRotas = lazy(() => import('./admin/AdminRotas'))
const Protegido = lazy(() => import('./admin/Protegido'))

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* Fora do ProtectedRoute: aquele é o login de CLIENTE da doc; o painel é
            da equipe Pacto, com login Google via Keycloak. /admin/callback é o
            retorno do Google, tratado pelo ProvedorSessao. */}
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div className="loading-container">Carregando…</div>}>
              <Protegido>
                <AdminRotas />
              </Protegido>
            </Suspense>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Suspense fallback={
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh',
                  fontSize: '18px',
                  color: '#666'
                }}>
                  Carregando documentação...
                </div>
              }>
                <DocsPage />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
